import { mediaQuery, scrollTo } from './utils/functions.js';
// import { applyPixelEffect, applyPixelEffect2 } from './components/PixelImage.js';
// import { prlxEffect } from './components/Prlx.js';

function requireAll(r){
  r.keys().forEach(r);
}


const timer = (func, delay)=>{
  setTimeout(()=>{
    func();
  }, delay);
}


const pageWrapper = document.querySelector('.lp25-page-wrapper');
const staticImages = document.querySelectorAll('.lp25-page-wrapper .block__cover-image--static');
let isVertical = false;
let windowHeight = window.innerHeight;

const resizeHandler = (e)=>{
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  // get x position of the footer
  // lastLookItemY = lastLookItem.getBoundingClientRect().top + window.scrollY;
  window.dispatchEvent(new Event('scroll'));
  windowHeight = window.innerHeight;

  if(window.innerWidth < window.innerHeight){
    isVertical = true;
  } else {
    isVertical = false;
  }

  staticImages.forEach((image)=>{
    const fixedImage = image.nextElementSibling;
    fixedImage.style.width = `${image.getBoundingClientRect().width}px`;
    fixedImage.style.left = `${image.getBoundingClientRect().left}px`;
  });
  
}

window.addEventListener('load', resizeHandler);
window.addEventListener('resize', resizeHandler);

window.addEventListener('DOMContentLoaded', () => {

  const slides = document.querySelectorAll('.lp25-page-wrapper .slider .slide');
  // clone each slide and append it to the slider
  slides.forEach((slide)=>{
    const clone = slide.cloneNode(true);
    // find img tag inside clone and remove class "pixel--auto"
    // const img = clone.querySelector('img');
    // if(img){
    //   img.classList.remove('pixel--auto');
    //   img.classList.add('pixel');
    // }
    document.querySelector('.lp25-page-wrapper .slider .slider-wrapper').appendChild(clone);
  });

  resizeHandler();

});


// Swiper.use([Autoplay, EffectCreative]);
pageWrapper.classList.remove("loaded");

let count = 0;


function init() {

  // applyPixelEffect('.pixel');
  // applyPixelEffect2('.slider');
  // prlxEffect('.prlx');
  timer(() => {
    pageWrapper.classList.add("loaded");
  }, 100); // 少し遅延させて適用

  const prlxElems = document.querySelectorAll(".prlx");

  // observe each prlx element
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (
        entry.isIntersecting &&
        entry.target.classList.contains("prlx") &&
        !entry.target.classList.contains("executed")
      ) {
        entry.target.classList.add('qued');
        observer.unobserve(entry.target);
  
        timer(() => {
          entry.target.classList.add('executed');
  
          if (entry.target.classList.contains("slider")) {
            console.log('aaaaa');
            const slides = entry.target.querySelectorAll('.slide');
            slides.forEach((slide, index) => {
              timer(() => {
                slide.classList.add('executed');
              }, 100 * index);
            });
          }
  
        }, 100 * count);
  
        count++;
      }
    });
  
    count = 0;
  }, {
    rootMargin: '0px',
    threshold: 0.2,
  });
  

  // observe each prlx element
  prlxElems.forEach((prlxElem) => {
    observer.observe(prlxElem);
  });
  

}

window.addEventListener("load", init);

let st = window.scrollY;
window.addEventListener('scroll', ()=>{
  // st = window.scrollY;

  // const scrollAmount = windowHeight * 2;

  // if(st > scrollAmount){
  //   pageWrapper.classList.add('scrolled');
  // } else {
  //   pageWrapper.classList.remove('scrolled');
  // }


  // let pageHeaderY = Math.min(0, (lastLookItemY - (st)) * 0.3);

  // console.log(pageHeaderY)

  // if(lastLookItemY < st + window.innerHeight){
  //   pageHeader.style.transform = `${pageHeaderY}px`;
  // } else {
  //   pageHeader.style.transform = `${pageHeaderY}px`;
  // }

  // let scrollX = window.scrollX;
  //heroSection.style.transform = `translateX(-${scrollX}px)`;

});

// trigger scroll event
window.dispatchEvent(new Event('scroll'));

const openModalButtons = document.querySelectorAll('.open-modal-button');
const modalCloseButton = document.querySelector('.modal__close-button');
const modal = document.querySelector('.modal');
const modalInner = document.querySelector('.modal__inner');
const looks = document.querySelectorAll('.look');

openModalButtons.forEach((button)=>{
  button.addEventListener('click', ()=>{
    modal.classList.add('active');
    const target = button.dataset.id ? button.dataset.id - 1 : 0;


    
    // get offset top of the target element
    const targetTop = target == 0 ? 0 : looks[target].offsetTop - 30;

    scrollTo({to: targetTop, element: modalInner, duration: 800});

  });
}
);

modalCloseButton.addEventListener('click', ()=>{
  modal.classList.remove('active');
});

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top < window.innerHeight * 0.75 &&
    rect.bottom > window.innerHeight * 0.25
  );
}

const allSlides = document.querySelectorAll('.lp25-page-wrapper .slider .slide');
document.addEventListener("DOMContentLoaded", () => {
  const prlxElems = document.querySelectorAll(".block__cover, .prlx--block");

  //const staticImages = document.querySelectorAll(".block__cover-image--static");
  // watch if the staitcImage is in view with observer

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.closest('.block__cover').classList.add("in-view");
      } else {
        entry.target.closest('.block__cover').classList.remove("in-view");
      }
    });
  }
  , {
    rootMargin: '100px',
    threshold: 0.5,
  });

  // observe each static image
  staticImages.forEach((image) => {
    observer.observe(image);
  });


  //let count = 0;
  const scrollHandler = () => {
    //count = 0;
    prlxElems.forEach((prlxElem) => {

      const rect = prlxElem.getBoundingClientRect();
      // get height of the element
      const elemHeight = rect.height;
      const windowHeight = window.innerHeight;
      const st = window.scrollY;

      if(prlxElem.classList.contains("block__cover") && !prlxElem.classList.contains("executed")){


        if(rect.top < windowHeight * 0.7){
          prlxElem.classList.add("img-visible");
        }
        

        if(isVertical == true){

          //check if the element's top reached the top of the screen

          if (rect.top < 0) {
            prlxElem.classList.add("fixed", "vertical");
          } else {
            prlxElem.classList.remove("fixed", "vertical");
          }

        } else {

          //check if the element's bottom reached the bottom of the screen
          prlxElem.classList.remove("vertical");
          // console.log(rect.top)
          // //console.log(rect.bottom)
          // if (rect.top > (windowHeight - elemHeight) && rect.top < elemHeight) {
          //   prlxElem.classList.add("in-view");
          // } else {
          //   prlxElem.classList.remove("in-view");
          // }

          if (rect.bottom < windowHeight) {
            // check if the element is in the viewport
            // if (rect.top < windowHeight) {
            //   prlxElem.classList.add("fixed");
            // }

            prlxElem.classList.add("fixed");
          } else {
            prlxElem.classList.remove("fixed");
          }

        }

      } else if (prlxElem.classList.contains("credit__image")) {

        if (prlxElem.classList.contains("executed")) {
          return;
        }

        const distance = -((rect.top + st) - (st + windowHeight));

        // if image is first element in the stack

        let ratio = distance / windowHeight;


      } else {
        
        if(prlxElem.classList.contains("lineup-section")){
          if(rect.top < windowHeight){  
            pageWrapper.classList.add("hide-block-cover");
          } else {
            pageWrapper.classList.remove("hide-block-cover");
          }
          return;
        }

        // if(rect.top < (windowHeight * 0.8)){          
        //   if(prlxElem.classList.contains("qued")){
        //     return;
        //   }
        //   timer(() => {
        //     prlxElem.classList.add("executed");
        //   }, 100 * count);
        //   prlxElem.classList.add("qued");
        //   count++;
        // }
      }

    });
  };

  window.addEventListener("scroll", scrollHandler);
  scrollHandler(); // 初回実行


  // fire scroll event every 2000s
  setInterval(() => {
    window.dispatchEvent(new Event('scroll'));
  }, 1000);

});






